<input
  #radio
  type="radio"
  [attr.data-testid]="testId()"
  [attr.disabled]="disabled ? true : null"
  [formControl]="control"
  [id]="forId"
  [value]="value"
/>
<label [for]="forId">{{ label }}</label>
